import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Mic, Stop, CloudUpload } from "@mui/icons-material";
import AudiotrackOutlinedIcon from "@mui/icons-material/AudiotrackOutlined";
import { getHeader, getMultipartHeader, getToken } from "../../utils/util";
import { GlassButton } from "../../themes/UiElements";
const UploadAudio = ({ apiEndpoint, onSuccess, onError }) => {
  const [open, setOpen] = useState(false);
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState("");
  const [audioBlob, setAudioBlob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const audioChunks = [];
      recorder.ondataavailable = (e) => audioChunks.push(e.data);
      recorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setAudioURL(url);
        setAudioBlob(blob);
        stream.getTracks().forEach((track) => track.stop());
      };

      recorder.start();
      setMediaRecorder(recorder);
      setRecording(true);
    } catch (err) {
      console.error("Recording failed:", err);
      onError?.(new Error("Microphone access denied"));
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setRecording(false);
    }
  };

  const uploadAudio = async () => {
    if (!audioBlob || !apiEndpoint) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("audio", audioBlob, "recording.webm");

      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${getToken()}`, // Add Bearer token to headers
        },
      });

      if (response.ok) {
        const data = await response.json();
        onSuccess?.(data);
        handleClose();
      } else {
        throw new Error("Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      onError?.(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setRecording(false);
    setAudioURL("");
    setAudioBlob(null);
  };

  return (
    <>
      <GlassButton
        startIcon={<AudiotrackOutlinedIcon />}
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
      >
        Record Audio
      </GlassButton>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Audio Recorder</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <IconButton
              color={recording ? "secondary" : "primary"}
              onClick={recording ? stopRecording : startRecording}
              disabled={loading}
            >
              {recording ? <Stop fontSize="large" /> : <Mic fontSize="large" />}
            </IconButton>

            {audioURL && (
              <audio
                controls
                src={audioURL}
                style={{ marginTop: 20, width: "100%" }}
              />
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={uploadAudio}
            disabled={!audioURL || loading || !apiEndpoint}
            startIcon={
              loading ? <CircularProgress size={20} /> : <CloudUpload />
            }
            color="primary"
          >
            {loading ? "Uploading..." : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadAudio;
